import { addMonths, endOfDay, setDate, setHours } from 'date-fns';

export const estimateCorporateDonationProcessedAt = (provider: string) => {
  const today = new Date();

  if (provider === 'GlobalGiving') {
    // @NOTE-RT: We typically process GlobalGiving in the first week, by the 5th
    return setHours(endOfDay(setDate(addMonths(today, 1), 5)), 11);
  }

  // @NOTE-RT: For everyone else, just assume that we'll process it before the 15th
  return setHours(endOfDay(setDate(addMonths(today, 1), 15)), 11);
};

export default estimateCorporateDonationProcessedAt;
